import {
  getDefaultNode as getFoundationsDefaultNode,
  setDefaultNode as setFoundationsDefaultNode,
} from 'foundations-components/transitional/utils/RootNode';

export const setDefaultNode = (node: HTMLElement): void => {
  setFoundationsDefaultNode(node);
};

export const getDefaultNode = (): HTMLElement => {
  return getFoundationsDefaultNode();
};
